import { render, staticRenderFns } from "./DharmaAssembly.vue?vue&type=template&id=0ae585b0&scoped=true"
import script from "./DharmaAssembly.vue?vue&type=script&lang=tsx"
export * from "./DharmaAssembly.vue?vue&type=script&lang=tsx"
import style0 from "./DharmaAssembly.vue?vue&type=style&index=0&id=0ae585b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae585b0",
  null
  
)

export default component.exports